angular.module('hal-common').factory('HALResource', [
  '$resource',
  function ($resource) {
    return {
      search: $resource(
        '/apiv3/hal/search',
        { query: '@query', ruleset_id: '@ruleset_id' },
        {
          query: { method: 'GET' },
          fullMatch: {
            method: 'GET',
            is_array: false,
            url: '/apiv3/hal/search/full-match',
          },
          images: {
            method: 'GET',
            url: '/apiv3/hal/search/images',
            isArray: false,
          },
          selectImage: {
            method: 'POST',
            url: '/apiv3/hal/search/select-image',
            params: {
              query: '@query',
              resource_id: '@resource_id',
              resource_type: '@resource_type',
              action: '@action',
              result_position: '@result_position',
            },
          },
          selectWord: {
            method: 'POST',
            url: '/apiv3/hal/search/select-word',
            params: {
              word_id: '@word_id',
            },
          },
          backgrounds: {
            method: 'GET',
            isArray: false,
            url: '/apiv3/hal/search/backgrounds',
          },
          giphy: {
            method: 'GET',
            isArray: false,
            url: '/apiv3/hal/search/giphy',
          },
          google: {
            method: 'GET',
            isArray: false,
            url: '/apiv3/hal/search/google',
          },
        }
      ),
      images: $resource('/apiv3/hal/images', { word_id: '@word_id' }),
      generator: $resource(
        '/apiv3/hal/generator/:id',
        { id: '@id' },
        {
          store: { method: 'POST' },
          show: { method: 'GET' },
        }
      ),
    };
  },
]);
